export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/http-worker.73670b39.worker.js");
}
